import * as actionsTypes from "./actionTypes";


const searchConsoleUsers = searchFields => ({
    type: actionsTypes.CONSOLE_USER_SEARCH_REQUEST,
    searchFields
});

const getConsoleUserData = consoleUserId => ({
    type: actionsTypes.GET_CONSOLE_USER_REQUEST,
    consoleUserId
});

const createConsoleUser = consoleUserData => ({
    type: actionsTypes.CREATE_CONSOLE_USER_REQUEST,
    consoleUserData
});

const editConsoleUser = (consoleUserId, consoleUserData) => ({
    type: actionsTypes.EDIT_CONSOLE_USER_REQUEST,
    consoleUserId,
    consoleUserData
});

const deleteConsoleUser = consoleUserId => ({
    type: actionsTypes.DELETE_CONSOLE_USER_REQUEST,
    consoleUserId
});

const resetConsoleUserForm = () => ({
    type: actionsTypes.RESET_CONSOLE_USER_FORM
});



export default {
    searchConsoleUsers,
    getConsoleUserData,
    createConsoleUser,
    editConsoleUser,
    deleteConsoleUser,
    resetConsoleUserForm
}